module.exports = {"441826100":"三江镇","441826101":"大麦山镇","441826102":"寨岗镇","441826105":"三排镇","441826106":"涡水镇","441826108":"大坪镇","441826109":"香坪镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/441826.json
// module id = 1877
// module chunks = 0